import { IMerchantLogin } from "@/pages/auth/_misc/type";
import { useSessionStorage } from "usehooks-ts";
export const useMerchantDetail = () => {
  const [merchantLogin, setMerchantLogin, removeMerchantLogin] =
    useSessionStorage<IMerchantLogin>("merchant_details", {} as IMerchantLogin);

  return {
    setMerchantLogin,
    merchantLogin,
    removeMerchantLogin,
  };
};
